import { create } from 'zustand';

export const useNotificationStore = create((set) => ({
  notifications: [],
  push: (n) => set((s) => ({ notifications: [...s.notifications, { id: Math.random().toString(36).slice(2), ...n }] })),
  dismiss: (id) => set((s) => ({ notifications: s.notifications.filter((n) => n.id !== id) })),
}));

export function useNotify() {
  const push = useNotificationStore((s) => s.push);
  return {
    success: (message) => push({ message, severity: 'success' }),
    error:   (message) => push({ message, severity: 'error' }),
    info:    (message) => push({ message, severity: 'info' }),
    warn:    (message) => push({ message, severity: 'warning' }),
  };
}
